// modules
import React, { FC } from 'react';
import { Text, View } from '@upstox/upstox-ui';
import Localization from 'modules/Localization';
// assets
import ErrorIcon from 'assets/error_illustration.svg';
// styles
import * as css from './styles';

const PriceAlertsErrorState: FC = () => (
  <View css={css.container}>
    <img alt="error" src={ErrorIcon} draggable={false} />
    <Text css={css.title}>
      {Localization.translate('DEFAULT_ERROR_MESSAGE')}
    </Text>
    <Text css={css.subtitle}>{Localization.translate('RETRY_MESSAGE')}</Text>
  </View>
);

export default PriceAlertsErrorState;
